import { render } from "./ModalFormOrder.vue?vue&type=template&id=140caa6c"
import script from "./ModalFormOrder.vue?vue&type=script&lang=js"
export * from "./ModalFormOrder.vue?vue&type=script&lang=js"

import exportComponent from "/vue-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__